import { ResponseError } from '../../errors';
import { fetchMessagesUnread, TMessagesUnreadResponse } from '../../repositories/chats/v1/messages-unread';
import { IApplicationContext } from '../../types/applicationContext';

export async function getUnreadMessages(
  context: IApplicationContext,
  isAuthenticated: boolean,
  parameters = {},
): Promise<number> {
  if (!isAuthenticated) {
    return 0;
  }

  const { httpApi, logger } = context;

  try {
    const messages: TMessagesUnreadResponse = await fetchMessagesUnread({
      httpApi,
      parameters,
    });

    if (messages.statusCode !== 200) {
      throw new ResponseError({
        domain: 'getUnreadMessages',
        message: messages.response.message,
        details: {
          error: messages.response.errors,
        },
      });
    }

    return messages.response.unread || 0;
  } catch (ex) {
    logger.warning(ex, {
      domain: 'getUnreadMessages',
      message: 'Failed to get unread messages',
    });

    return 0;
  }
}
